
export function verificarSeHouveAlteracoes(
  original: any,
  formulario: any,
  setOpenPopover: Function,
  onClose: Function
) {
  let data_da_os: boolean = String(original?.data_da_os ?? '') === String(formulario?.data_da_os ?? '')
  let outros_solicitantes: boolean = String(original?.outros_solicitantes ?? '') === String(formulario?.outros_solicitantes ?? '')
  let propriedade: boolean = String(original?.propriedade ?? '') === String(formulario?.propriedade ?? '')
  let talhao: boolean = String(original?.talhao ?? '') === String(formulario?.talhao ?? '')
  let laboratorio: boolean = String(original?.laboratorio ?? '') === String(formulario?.laboratorio ?? '')
  let safra_consultoria: boolean = String(original?.safra_consultoria ?? '') === String(formulario?.safra_consultoria ?? '')
  let area_amostra_laudo: boolean = String(original?.area_amostra_laudo ?? '') === String(formulario?.area_amostra_laudo ?? '')
  let coleta_liberada: boolean = String(original?.coleta_liberada ?? '') === String(formulario?.coleta_liberada ?? '')
  let coletada_em: boolean = String(original?.coletada_em ?? '') === String(formulario?.coletada_em ?? '')
  let representante_selecionado: boolean = String(original?.representante_selecionado ?? '') === String(formulario?.representante_selecionado ?? '')
  let analises: boolean = JSON.stringify(original?.analises ?? []) === JSON.stringify(formulario?.analises ?? [])
  let responsaveis: boolean = JSON.stringify(original?.responsaveis_selecionados ?? []) === JSON.stringify(formulario?.responsaveis_selecionados ?? [])

  const campos = {
    data_da_os,
    outros_solicitantes,
    propriedade,
    talhao,
    laboratorio,
    safra_consultoria,
    area_amostra_laudo,
    coleta_liberada,
    coletada_em,
    representante_selecionado,
    analises,
    responsaveis,
  }

  const possui_campo_alterado: boolean = Object.values(campos).includes(false)

  if (possui_campo_alterado) {
    setOpenPopover(true)
  } else {
    onClose()
  }
}

export function verificarSeAlgoEstaPreenchido(
  formulario: any,
  setOpenPopover: Function,
  onClose: Function
) {
  let data_da_os: boolean = String(formulario?.data_da_os ?? '') !== ''
  let outros_solicitantes: boolean = String(formulario?.outros_solicitantes ?? '') !== ''
  let propriedade: boolean = String(formulario?.propriedade ?? '') !== ''
  let talhao: boolean = String(formulario?.talhao ?? '') !== ''
  let laboratorio: boolean = String(formulario?.laboratorio ?? '') !== ''
  let safra_consultoria: boolean = String(formulario?.safra_consultoria ?? '') !== ''
  let coleta_liberada: boolean = String(formulario?.coleta_liberada ?? '') !== ''
  let coletada_em: boolean = String(formulario?.coletada_em ?? '') !== ''
  let representante_selecionado: boolean = String(formulario?.representante_selecionado ?? '') !== ''
  let analises: boolean = (formulario?.analises ?? []).length > 0
  let responsaveis: boolean = (formulario?.responsaveis_selecionados ?? []).length > 0

  const campos = {
    data_da_os,
    outros_solicitantes,
    propriedade,
    talhao,
    laboratorio,
    safra_consultoria,
    coleta_liberada,
    coletada_em,
    representante_selecionado,
    analises,
    responsaveis,
  }

  const possui_campo_preenchido: boolean = Object.values(campos).includes(true)

  if (possui_campo_preenchido) {
    setOpenPopover(true)
  } else {
    onClose()
  }
}
